/**
 * @file Create account identity container for album folder purchase.
 */

import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { MeWithIdentitiesAndSubscribed } from '../../graphql/queries/account';
import CreateAccountIdentityContainer, {
  CreateAccountIdentityComponentContainer,
} from '../../apps/consumer/containers/CreateAccountIdentityContainer';
import { identityCreate } from '../../graphql/mutations/identity';

const withIdentityCreate = graphql(identityCreate, {
  props: ({ mutate, ownProps }) => ({
    identityCreateMutation: ({
      accountId,
      firstName,
      lastName,
      gender,
      photoId,
    }) =>
      mutate({
        variables: {
          input: {
            account_id: accountId,
            name: firstName,
            last_name: lastName,
            relationship: 'SECONDARY',
            photo_id: photoId,
            gender,
            selfie_verify: true,
          },
        },
        update: (
          store,
          {
            data: {
              identityCreate: { identity },
            },
          },
        ) => {
          const data = store.readQuery({
            query: MeWithIdentitiesAndSubscribed,
            variables: {
              albumFolderIds: [ownProps.match.params.albumFolderId],
            },
          });

          store.writeQuery({
            query: MeWithIdentitiesAndSubscribed,
            variables: {
              albumFolderIds: [ownProps.match.params.albumFolderId],
            },
            data: {
              ...data,
              me: {
                ...data.me,
                linked_identities: {
                  ...data.me.linked_identities,
                  records: [...data.me.linked_identities.records, identity],
                },
              },
            },
          });
        },
      }),
  }),
});

export const AlbumFolderPurchaseCreateAccountIdentityComponentContainer = compose(
  withRouter,
  withIdentityCreate,
)(CreateAccountIdentityComponentContainer);

export default compose(
  withRouter,
  withIdentityCreate,
)(CreateAccountIdentityContainer);
